import React, { Component } from 'react';
import { obtenerValoresFiltros, obtenerMisDatos } from "../../../global/js/funciones";
import { Paper, Grid, Typography, Button, Dialog, DialogContent, DialogActions, Box, Divider } from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import dinero_marron from '../../../global/imagenes/dinero_marron.png';
import dinero_renovacion from '../../../global/imagenes/dinero_renovacion.png';
import dinero from '../../../global/imagenes/dinero.png';
import dinero_otras from '../../../global/imagenes/otras_entidades.png';
import one2 from '../../../global/imagenes/one2.png';
import icetex from '../../../global/imagenes/icetex.png';
import crearone2 from '../../../global/imagenes/estado-financiero-consultar.png';
import conocenos from '../../../global/imagenes/lightbulb.png';
import dudas from '../../../global/imagenes/question.png';
import CreditoFormAgregar from "./CreditoFormAgregar";
import CreditoOpcionesTipo from "./CreditoOpcionesTipo";
import CreditoFormuDirecto from "../creditos/CreditoFormuDirecto";
import { mostrarModalAddCredito, mostrarModalFormuDirecto} from "../../.././redux/actions/actCreditos";
import { connect } from "react-redux";
import { actualizarMensaje, mostrarModulo } from "../../.././redux/actions/actGlobal";
import AppBarModal from '../../general/AppBarModal';
import { BtnForm } from '../../general/BotonesAccion';
import { REQUISITOS_CREDITOS,CREDITO_DIRECTO_POARA,CREDITO_DIRECTO_OCUPACION } from "./../helper";


class CreditoAgregar extends Component {

  constructor(props) {
    super(props)
    this.state = {
      seleccion: 'inicio',
      titulo: 'inicio',
      categoria: '',
      tipo: '',
      cargando: true,
      mensaje_icetex: '',
      mensaje_otras: '',
      mensajes_nuevo: '',
      mensajes_renovacion: '',
      requisitos: [],
      credito_para:[],
      datos_sesion: [],
      telefono_contacto:'',
      direccion_per:'',
      correo_personal:'',
      lugar_expedicion:'',
      estado_civil:'',
      lugar_residencia:'',
      programas: [],
      Ocupacion:[],
      detalleEntidad: ''
    }
  }

  async componentDidMount() {
    this.obtenerInformacion();
    this.obtenerRequisitosCreditos();
    this.obtenerCredito_para();
    this.obtenerOcupacion();
    let datos_sesion = await obtenerMisDatos();
    this.setState({cargando:false, datos_sesion});
    this.obtenerDatosBasicos();
  }

  async componentDidUpdate({ }, { seleccion }) {
    let { seleccion: seleccionNew } = this.state;
    if (seleccionNew !== seleccion) {
    }
  }

  async obtenerInformacion() {
    let icetex = await obtenerValoresFiltros([{ 'llave': 'codigo', 'valor': 'Ice_Cre' }]);
    let otras = await obtenerValoresFiltros([{ 'llave': 'codigo', 'valor': 'Ent_Cre' }]);
    let directo = await obtenerValoresFiltros([{ 'llave': 'codigo', 'valor': 'Direc_Cre' }]); 
    if (icetex.length > 0 && otras.length > 0 && directo.length > 0) this.setState({ mensaje_icetex: icetex[0].descripcion, mensaje_otras: otras[0].descripcion, mensaje_directo: directo[0].descripcion, mensajes_nuevo: [icetex[0].valora, otras[0].valora], mensajes_renovacion: [icetex[0].valorb, otras[0].valorb] })
  }

  obtenerRequisitosCreditos = async () => {
    this.setState({ cargando: true });
    const requisitosCR = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': REQUISITOS_CREDITOS }, { 'llave': 'estado', 'valor': 1 }])
    this.setState({
      requisitos: requisitosCR,
      cargando: false,
    });
  }

  obtenerCredito_para = async () => {
    this.setState({ cargando: true });
    const creditoPara = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': CREDITO_DIRECTO_POARA }, { 'llave': 'estado', 'valor': 1 }])
    this.setState({
      credito_para: creditoPara,
      cargando: false,
    });
  }

  obtenerOcupacion = async () => {
    this.setState({ cargando: true });
    const ocupacion = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': CREDITO_DIRECTO_OCUPACION }, { 'llave': 'estado', 'valor': 1 }])
    this.setState({
      Ocupacion: ocupacion,
      cargando: false,
    });
  }

  onChange = ({ target }) => {
    let { value, name } = target;
    this.setState({
      [name]: value
    })
  }

  obtenerDatosBasicos =() => {
    let {datos_sesion} = this.state
    if (datos_sesion && datos_sesion.persona){
      let telefono_contacto = datos_sesion.persona.celular
      let direccion_per = datos_sesion.persona.direccion
      let correo_personal = datos_sesion.persona.correo_personal
      let lugar_expedicion = datos_sesion.persona.lugar_expedicion
      let estado_civil = datos_sesion.persona.estado_civil
      let lugar_residencia = datos_sesion.persona.lugar_residencia
      let programas=datos_sesion.programas
      this.setState({telefono_contacto,direccion_per,correo_personal,lugar_expedicion,estado_civil,lugar_residencia,programas});
    }
  }

  renderInicio() {
    let { setMenu,tipoSolicitud } = this.props;
    return (
      <div className=''>
        <Button onClick={() => setMenu()} style={{ padding: "0px 3px 0px 3px", marginTop: '1%' }} color="secondary" > <ArrowBackIcon /> <Typography variant="body2" style={{ color: '#9e9e9e' }} component="p" align='justify'> Atras </Typography> </Button>
        <div>
          <Grid container direction={'row'} justifyContent={'center'} style={{ paddingTop: 30 }} >
            <Grid item xs={12} sm={12} md={10} lg={8}>
              <Grid container direction={'row'} justify={'center'}>
                {tipoSolicitud.codigo === 'sol_cred' &&
                  <Grid item xs={12} sm={12} md={5} lg={5} style={{ padding: '2% 2% 0% 2%' }} onClick={() => this.setState({ tipo: 'icetex' })}>
                    <Paper elevation={8} style={{ borderRadius: '12px', overflow: 'hidden' }}>
                      <CreditoOpcionesTipo avatarcss={{ background: '#01579b' }} cardcss={{ maxWidth: "100%", height: '350px', cursor: 'pointer' }} image={icetex} data={{ opciones: `Crédito nuevo o renovación`, nombre: 'CRÉDITO ICETEX', descripcion: this.state.mensaje_icetex }} />
                    </Paper>
                  </Grid>
                }
                {
                  tipoSolicitud.codigo === 'sol_cred' &&
                  <Grid item xs={12} sm={12} md={5} lg={5} style={{ padding: '2% 2% 0% 2%' }} onClick={() => this.setState({ tipo: 'entidades' })}>
                    <Paper elevation={8} style={{ borderRadius: '12px', overflow: 'hidden' }}>
                      <CreditoOpcionesTipo avatarcss={{ background: '#4094d7' }} cardcss={{ maxWidth: "100%", height: '350px', cursor: 'pointer' }} imagecss = {{ width: '180px', maxWidth: '200px', minWidth: '100px', height: "130px" }}  image={dinero_otras} data={{ opciones: `Crédito nuevo`, nombre: 'OTRAS ENTIDADES', descripcion: this.state.mensaje_otras }} />
                    </Paper>
                  </Grid>
                }
                { tipoSolicitud.codigo === 'sol_directo' &&
                  <Grid item xs={12} sm={12} md={5} lg={5} style={{ padding: '2% 2% 0% 2%' }} onClick={() => this.props.mostrarModalFormuDirecto(true)}>
                  <Paper elevation={8} style={{ borderRadius: '12px', overflow: 'hidden' }}>
                    <CreditoOpcionesTipo avatarcss={{ background: '#f57f17' }} cardcss={{ maxWidth: "100%", height: '350px', cursor: 'pointer' }} image={dinero_marron} data={{ opciones: `Crédito directo`, nombre: 'CREDITO DIRECTO', descripcion: this.state.mensaje_directo }} />
                  </Paper>
                  </Grid>
                }
              </Grid>
            </Grid>
          </Grid>
        </div>
      </div>
    )
  }

  renderEntidades() {
    let { detalleEntidad } = this.state

    const detalleEntidadMap = {
      one2credit: (

        <Box sx={{ padding: 30 }}>
          <Typography variant="h4" style={{ fontWeight: '600', marginBottom: 8 }} gutterBottom>
            ¡Estudia sin límites con One2Credit!
          </Typography>

          <Typography variant="body2" style={{ marginBottom: 16 }}>
            Financia tu matrícula de forma rápida y segura, y haz realidad tus metas académicas.
          </Typography>

          <Divider style={{ marginBottom: 16 }} />

          <Typography variant="subtitle1" style={{ fontWeight: '500' }} gutterBottom>
            Requisitos
          </Typography>

          <ul style={{ marginTop: 0, marginBottom: 16, paddingLeft: 18 }}>
            <li>Cédula original</li>
            <li>Volante de matrícula activo</li>
            <li>Extractos bancarios de los últimos 3 meses</li>
            <li>Celular y correo electrónico activos</li>
          </ul>

          <Typography variant="subtitle1" style={{ fontWeight: '500' }} gutterBottom>
            Beneficios
          </Typography>

          <ul style={{ marginTop: 0, marginBottom: 24, paddingLeft: 18 }}>
            <li>Hasta el 100% de financiamiento</li>
            <li>Cuota inicial mínima del 10%</li>
            <li>Proceso 100% en línea</li>
            <li>Aprobación en 15 minutos</li>
          </ul>

          <Divider sx={{ mb: 2 }} />

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={() =>
                window.open('https://one2credit-app.kuenta.co/o/M_1P_VUIR', '_blank')
              }
            >
              Solicita tu crédito aquí
            </Button>

            <Button
              variant="text"
              onClick={() => window.open('https://www.one2credit.com', '_blank')}
            >
              Conócenos
            </Button>

            <Button
              variant="text"
              onClick={() => window.open('https://wa.me/573182856386', '_blank')}
            >
              ¿Dudas? Escríbenos por WhatsApp
            </Button>
          </Box>

        </Box>


      ),
      estrella: (
        <>
          <h1>Estrella</h1>
          {/* contenido específico */}
        </>
      ),
      // puedes seguir agregando más
    };


    return (
      <div className=''>
        <Button onClick={() => this.setState({ categoria: '', titulo: '', tipo: '' })} style={{ padding: "0px 3px 0px 3px", marginTop: '1%' }} color="secondary" > <ArrowBackIcon /> <Typography variant="body2" style={{ color: '#9e9e9e' }} component="p" align='justify'> Atras </Typography> </Button>
        <div>
          <Grid container direction={'row'} justifyContent={'center'} style={{ paddingTop: 30 }} >
            <Grid item xs={12} sm={12} md={10} lg={8}>
              <Grid container direction={'row'} justify={'center'}>
                  <>
                    <Grid item xs={12} sm={12} md={4} lg={4} style={{ padding: '2% 2% 0% 2%' }} onClick={() => this.setState({ detalleEntidad: 'one2credit' })}>
                      <Paper elevation={8} style={{ borderRadius: '12px', overflow: 'hidden' }}>
                        <CreditoOpcionesTipo avatarcss={{ background: '#4094d7' }} cardcss={{ maxWidth: "100%", height: '350px', cursor: 'pointer' }} image={one2} data={{ opciones: `Crédito nuevo`, nombre: 'CRÉDITO ONE2CREDIT', descripcion: 'ONE2CREDIT' }} />
                      </Paper>
                    </Grid> 

                    {/* <Grid item xs={12} sm={12} md={4} lg={4} style={{ padding: '2% 2% 0% 2%' }} onClick={() => this.setState({ detalleEntidad: 'estrella' })}>
                      <Paper elevation={8} style={{ borderRadius: '12px', overflow: 'hidden' }}>
                        <CreditoOpcionesTipo avatarcss={{ background: '#4094d7' }} cardcss={{ maxWidth: "100%", height: '350px', cursor: 'pointer' }} image={one2} data={{ opciones: `Crédito nuevo`, nombre: 'CRÉDITO ESTRELLA', descripcion: 'ESTRELLA' }} />
                      </Paper>
                    </Grid>  */}
                  </>
              </Grid>
            </Grid>
          </Grid>
        </div>


        <Dialog fullWidth={true} maxWidth="sm" open={detalleEntidad != ''} onClose={() => this.setState({ detalleEntidad: '' })}>
          <AppBarModal titulo={'Información Crédito'} mostrarModal={() => this.setState({ detalleEntidad: '' })} />
          <DialogContent style={{ padding: '0' }} className="scroll">
            {detalleEntidadMap[detalleEntidad] || null}
          </DialogContent>
          <DialogActions>
            <BtnForm texto="CERRAR" callback={() => this.setState({ detalleEntidad: '' })} />
          </DialogActions>
        </Dialog>
      </div>
    )
  }

  abrirTipo(categoria, titulo) {
    this.setState({ categoria, titulo })
    this.props.mostrarModalAddCredito(true);
  }

  renderNuevoRenovacion() {
    let { tipo, mensajes_nuevo, mensajes_renovacion } = this.state
    return (
      <>
        <Button onClick={() => this.setState({ categoria: '', titulo: '', tipo: '' })} style={{ padding: "0px 3px 0px 3px", marginTop: '1%' }} color="secondary" > <ArrowBackIcon /> <Typography variant="body2" style={{ color: '#9e9e9e' }} component="p" align='justify'> Atras </Typography> </Button>
        <Grid container direction={'row'} justifyContent={'center'} style={{ paddingTop: 30 }}>
          <Grid item xs={12} sm={12} md={10} lg={8}>
            <Grid container direction={'row'} justifyContent={'center'}>
              <Grid item xs={12} sm={12} md={5} lg={5} style={{ padding: '2% 2% 0% 2%' }} onClick={() => this.abrirTipo('nuevo', '¡ Nuevo crédito !')}>
                <Paper elevation={8} style={{ borderRadius: '12px', overflow: 'hidden' }}>
                  <CreditoOpcionesTipo avatarcss={{ background: '#01579b' }} cardcss={{ maxWidth: "100%", height: '350px', cursor: 'pointer' }} image={dinero} data={{ opciones: ``, nombre: 'CRÉDITO NUEVO', descripcion: (tipo === 'icetex') ? mensajes_nuevo[0] : mensajes_nuevo[1] }} />
                </Paper>
              </Grid>
              <Grid item xs={12} sm={12} md={5} lg={5} style={{ padding: '2% 2% 0% 2%' }} onClick={() => this.abrirTipo('renovacion', '¡ Renovación de crédito !')}>
                <Paper elevation={8} style={{ borderRadius: '12px', overflow: 'hidden' }}>
                  <CreditoOpcionesTipo avatarcss={{ background: '#01579b' }} cardcss={{ maxWidth: "100%", height: '350px', cursor: 'pointer' }} image={dinero_renovacion} data={{ opciones: ``, nombre: 'RENOVACIÓN DE CREDITO', descripcion: (tipo === 'icetex') ? mensajes_renovacion[0] : mensajes_renovacion[1] }} />
                </Paper>
              </Grid>
            </Grid>
          </Grid>
        </Grid >
      </>
    )
  }

    renderOne2Credit() {
    return (
      <>
        <Button onClick={() => this.setState({ categoria: '', titulo: '', tipo: '' })} style={{ padding: "0px 3px 0px 3px", marginTop: '1%' }} color="secondary" > <ArrowBackIcon /> <Typography variant="body2" style={{ color: '#9e9e9e' }} component="p" align='justify'> Atras </Typography> </Button>
        <Grid container direction={'row'} justifyContent={'center'} style={{ paddingTop: 30 }}>
          <Grid item xs={12} sm={12} md={10} lg={8}>
            <Grid container direction={'row'} justifyContent={'center'}>
              
              <Grid item xs={12} sm={12} md={4} lg={4} style={{ padding: '2% 2% 0% 2%' }} onClick={() => window.open("https://one2credit-app.kuenta.co/o/M_1P_VUIR", "_blank")}>
                <Paper elevation={8} style={{ borderRadius: '12px', overflow: 'hidden' }}>
                  <CreditoOpcionesTipo avatarcss={{ background: '#01579b' }} cardcss={{ maxWidth: "100%", height: '350px', cursor: 'pointer' }} image={crearone2} data={{ opciones: ``, nombre: 'Realiza tu simulación y solicitud de crédito fácil y rápido', descripcion: `Requisitos:
                    Cédula original. 
                    Ser colombiano, mayor de 18 y menor de 60 años.
                    Volante de matrícula activo. 
                    Extractos Bancarios últimos 3 meses.
                    Tener un celular y correo electrónico activos.` }} />
                </Paper>
              </Grid>

              <Grid item xs={12} sm={12} md={4} lg={4} style={{ padding: '2% 2% 0% 2%' }} onClick={() => window.open("https://www.one2credit.com/", "_blank")}>
                <Paper elevation={8} style={{ borderRadius: '12px', overflow: 'hidden' }}>
                  <CreditoOpcionesTipo avatarcss={{ background: '#01579b' }} cardcss={{ maxWidth: "100%", height: '350px', cursor: 'pointer' }} image={conocenos} data={{ opciones: ``, nombre: 'Conócenos un poco más', descripcion: 'Conócenos un poco más' }} />
                </Paper>
              </Grid>

              <Grid item xs={12} sm={12} md={4} lg={4} style={{ padding: '2% 2% 0% 2%' }} onClick={() => window.open("https://api.whatsapp.com/send/?phone=573182856386&text&type=phone_number&app_absent=0", "_blank")}>
                <Paper elevation={8} style={{ borderRadius: '12px', overflow: 'hidden' }}>
                  <CreditoOpcionesTipo avatarcss={{ background: '#01579b' }} cardcss={{ maxWidth: "100%", height: '350px', cursor: 'pointer' }} image={dudas} data={{ opciones: ``, nombre: 'Dudas o preguntas escríbenos por WhatsApp', descripcion: 'Dudas o preguntas escríbenos por WhatsApp' }} />
                </Paper>
              </Grid>
            </Grid>
          </Grid>
        </Grid >
      </>
    )
  }

  render() {
    let { seleccion, categoria, tipo, titulo,requisitos,credito_para,programas,Ocupacion,telefono_contacto,direccion_per,correo_personal,lugar_expedicion,estado_civil,lugar_residencia } = this.state;
    let { mostrarModalAddCredito, modalAddCredito, guardarCredito, guardarCreditodirecto, actualizarMensaje, tipoSolicitud,mostrarModalFormuDirecto,ModalFormuDirecto, usuario} = this.props;

    return (
      <div>
        {(seleccion === 'inicio' && !tipo) && this.renderInicio()}
        {tipo && tipo == 'icetex' && this.renderNuevoRenovacion()}
        {tipo && tipo == 'entidades' && this.renderEntidades()}
        <CreditoFormAgregar 
          actualizarMensaje={actualizarMensaje} 
          guardarCredito={guardarCredito} 
          categoria={categoria} tipo={tipo} 
          titulo={titulo} 
          modalAddCredito={modalAddCredito} 
          mostrarModalAddCredito={mostrarModalAddCredito} 
          tipoSolicitud={tipoSolicitud}
          usuario={usuario}
          />
          <CreditoFormuDirecto
            guardarCreditodirecto={guardarCreditodirecto}
            ModalFormuDirecto = {ModalFormuDirecto}
            mostrarModalFormuDirecto={mostrarModalFormuDirecto}
            requisitos={requisitos}
            credito_para={credito_para}
            telefono_contacto={telefono_contacto}
            direccion_per = {direccion_per}
            correo_personal = {correo_personal}
            lugar_expedicion = {lugar_expedicion}
            estado_civil = {estado_civil}
            lugar_residencia = {lugar_residencia}
            programas={programas}
            Ocupacion={Ocupacion}
            tipoSolicitud={tipoSolicitud}
            onChange= {this.onChange}

          />
      </div>
    )
  }
}



//CARGO ESTADOS DEL MODULO
const mapStateToProps = (state) => {
  let { modalAddCredito, ModalFormuDirecto } = state.redCreditos;
  return {
    modalAddCredito,
    ModalFormuDirecto
  }
};

//CARGO FUNCIONES DEL MODULO
const mapDispatchToProps = {
  actualizarMensaje,
  mostrarModulo,
  mostrarModalAddCredito,
  mostrarModalFormuDirecto
}





export default connect(mapStateToProps, mapDispatchToProps)(CreditoAgregar);